import React from 'react';
import { HeartPulseIcon, ShieldCheckIcon } from 'lucide-react';
const currentYear = new Date().getFullYear();
export function Footer() {
  return <footer className="bg-emerald-950 border-t border-emerald-800/40" data-id="element-38">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 max-w-5xl py-16" data-id="element-39">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-8 max-w-3xl mx-auto" data-id="element-40">
          {/* Brand Column */}
          <div className="text-center" data-id="element-41">
            <div className="flex items-center justify-center gap-2 mb-4" data-id="element-42">
              <HeartPulseIcon className="w-6 h-6 text-gold-400" data-id="element-43" />
              <span className="font-heading font-bold text-xl text-white tracking-wide" data-id="element-44">
                BIO-FITNESS
              </span>
            </div>
            <p className="text-emerald-200/60 font-body text-sm leading-relaxed max-w-xs mx-auto" data-id="element-45">
              El primer método de entrenamiento diseñado para la biología
              femenina. Sincroniza tu ejercicio con tu ciclo hormonal y
              transforma tu cuerpo sin agotamiento.
            </p>
            {/* Trust Badge */}
            <div className="mt-5 flex items-center justify-center gap-2 text-emerald-200/40 text-xs font-body" data-id="element-46">
              <ShieldCheckIcon className="w-4 h-4 text-gold-500/50" data-id="element-47" />
              <span data-id="element-48">Pago 100% seguro y encriptado</span>
            </div>
          </div>

          {/* Quick Info Column */}
          <div className="text-center" data-id="element-49">
            <h4 className="font-heading font-bold text-sm text-gold-400 uppercase tracking-widest mb-4" data-id="element-50">
              Sobre el Método
            </h4>
            <ul className="space-y-3 font-body text-sm text-emerald-200/60" data-id="element-51">
              <li data-id="element-52">Entrenamiento basado en fases hormonales</li>
              <li data-id="element-53">Nutrición ciclo-sincrónica</li>
              <li data-id="element-54">Protocolo antiinflamatorio</li>
              <li data-id="element-55">Suplementación estratégica</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-emerald-800/30" data-id="element-56">
        <div className="container mx-auto px-4 max-w-5xl py-6" data-id="element-57">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-58">
            <p className="text-emerald-200/40 font-body text-xs" data-id="element-59">
              © {currentYear} Rutina Bio-Fitness. Todos los derechos
              reservados.
            </p>

            <nav className="flex flex-wrap items-center justify-center gap-4" aria-label="Políticas legales" data-id="element-60">
              <a href="#politica-de-privacidad" className="text-emerald-200/50 hover:text-gold-400 font-body text-xs transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-500 rounded" data-id="element-61">
                Política de Privacidad
              </a>
              <span className="text-emerald-800 select-none" aria-hidden="true" data-id="element-62">
                •
              </span>
              <a href="#terminos-y-condiciones" className="text-emerald-200/50 hover:text-gold-400 font-body text-xs transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-500 rounded" data-id="element-63">
                Términos y Condiciones
              </a>
              <span className="text-emerald-800 select-none" aria-hidden="true" data-id="element-64">
                •
              </span>
              <a href="#aviso-legal" className="text-emerald-200/50 hover:text-gold-400 font-body text-xs transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-500 rounded" data-id="element-65">
                Aviso Legal
              </a>
            </nav>
          </div>

          <p className="text-emerald-200/30 font-body text-[10px] text-center mt-4 max-w-2xl mx-auto leading-relaxed" data-id="element-66">
            Descargo de responsabilidad: Los resultados pueden variar según cada
            persona. Este producto es un recurso educativo y no sustituye el
            consejo médico profesional. Consulta a tu médico antes de iniciar
            cualquier programa de ejercicio o nutrición.
          </p>
        </div>
      </div>
    </footer>;
}